import { render, staticRenderFns } from "./EmailVerif.vue?vue&type=template&id=604623ba&"
import script from "./EmailVerif.vue?vue&type=script&lang=js&"
export * from "./EmailVerif.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports